/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Pc_Cmp_R_Ai_AcInputs */

const en_pc_cmp_r_ai_ac = /** @type {(inputs: Pc_Cmp_R_Ai_AcInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`AI Assistant, a paid add-on or higher plan`)
};

const zh_pc_cmp_r_ai_ac = /** @type {(inputs: Pc_Cmp_R_Ai_AcInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`AI 助手，需付费附加或更高套餐`)
};

/**
* | output |
* | --- |
* | "AI Assistant, a paid add-on or higher plan" |
*
* @param {Pc_Cmp_R_Ai_AcInputs} inputs
* @param {{ locale?: "en" | "zh" }} options
* @returns {LocalizedString}
*/
const pc_cmp_r_ai_ac = /** @type {((inputs?: Pc_Cmp_R_Ai_AcInputs, options?: { locale?: "en" | "zh" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Pc_Cmp_R_Ai_AcInputs, { locale?: "en" | "zh" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_pc_cmp_r_ai_ac(inputs)
	return zh_pc_cmp_r_ai_ac(inputs)
});
export { pc_cmp_r_ai_ac as "pc.cmp.r.ai.ac" }